// src/pages/SignupPage.jsx
import React, { useState } from 'react';
// import '../../styles/pages/SignupPage.css';
import '../styles/pages/SignupPage.css';

const SignupPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Signup data:', formData);
  };

  const handleGoogleSignup = () => {
    console.log('Google signup clicked');
  };

  return (
    <div className="signup-page">
      <div className="signup-container">
        {/* Left Column - Signup Form */}
        <div className="signup-form-column">
          {/* Centered Header */}
          <div className="signup-header">
            <h1 className="signup-title">Vardhman</h1>
            <h2 className="signup-subtitle">Sign Up to Vardhman</h2>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Google Signup Button */}
            <button 
              type="button"
              onClick={handleGoogleSignup}
              className="google-signup-btn"
            >
              <span className="google-g">G</span>
              Sign up with Google
            </button>

            <div className="form-group">
              <label className="form-label">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-input"
                placeholder="First and last name"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                placeholder="This will be your login"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="form-input"
                placeholder="Choose a strong password"
                required
              />
              
              <div className="password-requirements">
                <div className="requirement-item">
                  <span className="requirement-dot">•</span>
                  <span>At least 8 characters</span>
                </div>
                <div className="requirement-item">
                  <span className="requirement-dot">•</span>
                  <span>A mixture of letters, numbers and special characters</span>
                </div>
                <div className="requirement-item">
                  <span className="requirement-dot">•</span>
                  <span>Cannot contain part of your email</span>
                </div>
              </div>
            </div>

            <div className="terms-text">
              By signing up, you agree to our Terms & Conditions and have read our Privacy Policy.
            </div>

            <div className="divider"></div>

            <button
              type="submit"
              className="submit-btn"
            >
              SIGN UP
            </button>

            <div className="login-link">
              <p className="login-text">
                Already have an account?{' '}
                <a href="#" className="login-link-text">
                  Log In
                </a>
              </p>
            </div>
          </form>
        </div>

        {/* Right Column - Testimonial with Image */}
        <div className="testimonial-column">
          {/* Image at top */}
          <div className="testimonial-image">
            <div className="testimonial-image-content">
              <div className="text-center text-white p-4">
                <div className="testimonial-icon">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <h3 className="testimonial-image-title">Vardhman Success</h3>
                <p className="testimonial-image-subtitle">Trusted by 10,000+ Sellers</p>
              </div>
            </div>
          </div>

          {/* Testimonial Text */}
          <div className="testimonial-text">
            <p className="mb-2">
              Absolutely the best product on the market for dealing with anything as a seller on Amazon!!!
            </p>
            <p className="mb-3">
              I can not think of anything else that your product could do expect sell the products for me! What is even more incredible about this product is the Freedom Ticket Training that you get for free with the purchase of your product!! Incredibly fantastic product and training!!!
            </p>
            
            {/* Author with profile image */}
            <div className="testimonial-author">
              <div className="author-avatar">
                M
              </div>
              <div>
                <p className="author-info-name">Michael Mosely</p>
                <p className="author-info-role">Verified Seller</p>
              </div>
            </div>

            {/* Star rating */}
            <div className="rating">
              {[...Array(5)].map((_, i) => (
                <svg key={i} className="star" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
              <span className="rating-text">5.0 Rating</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;